'use strict'
import api from '@/api/api'
import notify from "@/utils/notify"
import router from "@/router";

export default {
    async getProducts(params = {}) {
        const queryParams = new URLSearchParams();
        
        if (params.page) queryParams.append('page', params.page);
        if (params.per_page) queryParams.append('per_page', params.per_page);
        if (params.search) queryParams.append('search', params.search);
        if (params.status) queryParams.append('status', params.status);
        
        const queryString = queryParams.toString();
        const url = queryString ? `products?${queryString}` : 'products';
        
        const data = {
            method: 'get',
            url: url,
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        }
    },
    async getProductNextNo() {
        const data = {
            method: 'get',
            url: 'productNextNo',
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        }
    },
    async getProduct(id) {
        const data = {
            method: 'get',
            url: 'product/' + id,
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        }
    },
    async createProduct(json) {
        const data = {
            method: 'post',
            url: 'product',
            body: json,
        }

        const response = await api.api(data)
        if (response.status === 201) {
            notify.alert.success('Product added successfully')
            await router.push('/product/' + response.data.id)
        }
    },
    async updateProduct(json, id) {
        const data = {
            method: 'put',
            url: 'product/' + id,
            body: json,
        }

        const response = await api.api(data)
        if (response.status === 200) {
            notify.alert.success('Product updated successfully')
            router.push('/product/' + id)
        }
    },
    async uploadProductFile(json) {
        const data = {
            method: 'post',
            url: 'product/upload',
            body: json,
        }

        const response = await api.api(data)
        if (response.status === 200) {
            notify.alert.success('Products created successfully')
            return true;
        }
    },
    async getProductFiles(id) {
        const data = {
            method: 'get',
            url: 'product/files/' + id,
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        }
    },
    async updateProductAvatar(json) {
        const data = {
            method: 'post',
            url: 'product-avatar',
            body: json,
        }

        const response = await api.api(data)
        if (response.status === 200) {
            notify.alert.success('Product avatar updated successfully')
            return true;
        }
    },
    async updateProductStatus(id, status) {
        const data = {
            method: 'patch',
            url: 'product/' + id + '/status',
            body: { status },
        }

        const response = await api.api(data)
        if (response.status === 200) {
            notify.alert.success(`Product status updated to ${status}`)
            return response.data
        }
    },
}
